exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ncaab_landing__link--tckMi {\n  color: #f9f9f9;\n  font-size: 12px;\n}\n\n.ncaab_landing__linkContent--3YMpS {\n  padding: 10px 10px 0;\n}\n\n.ncaab_landing__arrow--3Qsd- {\n  background: no-repeat 50% 50% url(\"/static/vectors/page-1.svg\");\n  background-size: contain;\n  display: inline-block;\n  width: 17px;\n  height: 15px;\n  margin-right: 2px;\n  vertical-align: top;\n}\n\n.ncaab_landing__text--2WHVm {\n  display: inline-block;\n  vertical-align: top;\n}", ""]);

// exports
exports.locals = {
	"link": "ncaab_landing__link--tckMi",
	"linkContent": "ncaab_landing__linkContent--3YMpS",
	"arrow": "ncaab_landing__arrow--3Qsd-",
	"text": "ncaab_landing__text--2WHVm"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };